import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { diegoRoutes } from '@core/enums/orderflow-paths';
import { Dealer } from '@core/models/dealer.model';
import { UpdateActiveDealerAction } from '@core/states/dealer/dealer.actions';
import { Store } from '@ngxs/store';
import { MatOption } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';

@Component({
  selector: 'app-change-dealer-dialog',
  templateUrl: './change-dealer-dialog.component.html',
  styleUrls: ['./change-dealer-dialog.component.scss'],
  imports: [MatFormField, MatSelect, FormsModule, MatOption],
})
export class ChangeDealerDialogComponent {
  data = inject<{
    dealers: Dealer[];
    activeDealer: Dealer;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ChangeDealerDialogComponent>>(MatDialogRef);
  private store = inject(Store);
  private router = inject(Router);

  onChangeDealer({ value: dealerId }) {
    this.store.dispatch(
      new UpdateActiveDealerAction(this.data.dealers.find((dealer: Dealer) => dealer.dealerId === dealerId))
    );

    this.router.navigate([diegoRoutes.startSale]);

    this.dialogRef.close();
  }
}
